var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#00306E",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.926 31.7385V58H25.7924C23.7075 58 22 56.326 22 54.2741V27.5625C22 22.8466 25.5228 20.7047 29.8184 22.8106L37.7807 26.7525C39.5061 27.5985 40.926 29.8485 40.926 31.7385Z",
    fill: "#3270FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5814 35.9502H28.3446C27.6077 35.9502 26.9966 35.3382 26.9966 34.6002C26.9966 33.8622 27.6077 33.2502 28.3446 33.2502H34.5814C35.3183 33.2502 35.9294 33.8622 35.9294 34.6002C35.9294 35.3382 35.3362 35.9502 34.5814 35.9502Z",
    fill: "#3270FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5814 43.1499H28.3446C27.6077 43.1499 26.9966 42.5379 26.9966 41.7999C26.9966 41.0619 27.6077 40.45 28.3446 40.45H34.5814C35.3183 40.45 35.9294 41.0619 35.9294 41.7999C35.9294 42.5379 35.3362 43.1499 34.5814 43.1499Z",
    fill: "#3270FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M58 45.4899V53.4997C58 55.9837 55.987 57.9996 53.5067 57.9996H40.9253V37.156L41.77 37.336L49.0313 38.956L49.894 39.154L53.5606 39.982C54.4413 40.162 55.2501 40.4679 55.9511 40.9179C55.9511 40.9359 55.969 40.9359 55.969 40.9359C56.1488 41.0619 56.3285 41.2059 56.4903 41.3679C57.317 42.1959 57.8562 43.4019 57.9821 45.1659C57.9821 45.2739 58 45.3819 58 45.4899Z",
    fill: "#3270FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9253 37.156V47.9558C41.7521 49.0538 43.0462 49.7558 44.52 49.7558C47.0183 49.7558 49.0313 47.7398 49.0313 45.2559V38.974L41.77 37.354L40.9253 37.156Z",
    fill: "#3270FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9815 45.1658C57.8557 43.4019 57.3165 42.1959 56.4897 41.3679C56.328 41.2059 56.1482 41.0619 55.9685 40.9359C55.9685 40.9359 55.9505 40.9359 55.9505 40.9179C55.2496 40.4679 54.4408 40.1619 53.5601 39.9819L49.8935 39.1539L49.0308 38.9559V45.2558C49.0308 47.7218 51.0258 49.7557 53.5241 49.7557C55.9326 49.7557 57.8557 47.8658 57.9995 45.5078V45.4898C57.9995 45.3818 57.9815 45.2738 57.9815 45.1658Z",
    fill: "#3270FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.4d03e4cf4d727c9f14b1009df8c938c1.svg";
export { ForwardRef as ReactComponent };